/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers.  The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { BrandStateContext } from "@insite/client-framework/Store/Data/Brands/BrandsSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BrandDetailsPageContext } from "@insite/content-library/Pages/BrandDetailsPage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { FC, useContext } from "react";
import { css } from "styled-components";

interface Props extends WidgetProps {}

export interface BrandDetailsTitleStyles {
    heading?: TypographyProps;
}

export const brandDetailsTitleStyles: BrandDetailsTitleStyles = {
    heading: {
        variant: "h2",
        as: "h1",
        lineHeight: "34px",
        color: "secondary.main",
        css: css`
            overflow-wrap: break-word;
            word-wrap: break-word;
            margin-bottom: 30px;
        `,
    },
};

const styles = brandDetailsTitleStyles;

const BrandDetailsTitle: FC<Props> = () => {
    const { value: brand } = useContext(BrandStateContext);

    if (!brand) {
        return null;
    }

    return (
        <Typography data-test-selector="brandHeading" {...styles.heading}>
            {brand.name}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: BrandDetailsTitle,
    definition: {
        group: "Brand Details",
        displayName: "Brand Title",
        allowedContexts: [BrandDetailsPageContext],
    },
};

export default widgetModule;
